<template>
  <v-row>
    <v-col class="pa-0" cols="12">
      <!-- normal table -->
      <v-card flat>
        <v-card-text>
          <v-data-table evalution="0" :loading="loading" @update:options="changeOptions" :server-items-length="totalItems"
            :headers="headerList" :items="items" :hide-default-footer="$route.name == 'Dashboard'" :footer-props="{
            itemsPerPageOptions:[10,20,50,100],
            showFirstLastPage:true,
            showCurrentPage: true,
        }">
            <template  v-if="$route.name != 'Dashboard'" slot="top">
              <v-col cols="12" class="pt-2 d-flex" style="justify-content:flex-end">
                <v-btn depressed class="white--text rounded-xl" v-if="hasAdd" :to="{name : `add_${module}`}" color="#02c9b7">ایجاد</v-btn>
                <v-btn @click="$refs.Filter.ShowFilter = true" class="" icon>
                  <iconly name="filter2" type="bulk" color="#feb039" />
                </v-btn>
                <v-btn icon @click="getData">
                  <v-icon size="20" color="#feb039">fas fa-sync</v-icon>
                </v-btn>
              </v-col>
            </template>
            <template v-slot:item.data1="{item}">
              <slot name="data1" v-bind:item="item">
              </slot>
            </template>
            <template v-slot:item.actions="{item}">
              <slot name="additional" v-bind:item="item">
              </slot>
              <span v-for="(btn , i) in Actions" :key="i">
                <v-btn :to="{name: btn.url , params:{id : item.id}}" icon small>
                  <iconly :size="btn.size" :name="btn.icon" type="light" :color="btn.color" />
                </v-btn>
              </span>
              <v-btn v-if="hasDelete" icon @click="ShowDelete(item._id, item.code || item.name || item.fullname || item.model)">
                <iconly size="20" name="delete" type="light" color="red" />
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- delete dialog-->
    <v-dialog ref="Delete" v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="red white--text">حذف !</v-card-title>
        <v-card-text class="pt-3">
          <p>از حذف این رکورد اطمینان دارید؟</p>
          <p>شماره: <span class="font-weight-bold">{{ deleteTitle }}</span></p>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed color="error" :loading="deleteLoading" @click="ConfirmDelete()">
            بله حذف کن
          </v-btn>
          <v-btn class="float-left" text @click="deleteDialog=false">
            انصراف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SideFilter ref="Filter" @getData="getData" />
  </v-row>
</template>

<script>
  import SideFilter from './SideFilter';
  import {
    mapActions,
    mapState,
    mapGetters,
    mapMutations
  } from "vuex";

  export default {
    display: "Table",
    order: 8,
    props: {
      sortable_row: false,
      hasDelete: true,
      hasAdd: true
    },
    components: {
      SideFilter
    },
    data() {
      return {
        loading: false,
        loadingExport: false,
        reqStat: '',
        intiHeaders: [],
        url: '',
        items: [],
        groupBy: 0,
        export: false,
        isDesc: true,
        deliveryDateTime: '',
        sortOrder: 'name',
        sortDesc: true,
        pageNumber: 1,
        periodId: '',
        pageCount: 10,
        totalItems: 0,
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['name'],
          sortDesc: [true],
          descending: true,
          totalItems: 0
        },
        deleteDialog: false,
        deleteLoading: false,
        deleteTitle: '',
        deleteId: null,
        SortRow: false,
        intiHeaders: [],
      }
    },
    computed: {
      ...mapState(['headers', 'filters', 'module', 'pageTitle', 'groupHeaders',
        'Actions'
      ]),
      ...mapGetters(["getSorts"]),
      headerList() {
        return this.headers.filter(x => !x.hidden);
      },
      groupHeaderItems() {
        return this.groupHeaderList.filter(x => this.groupHeaders.indexOf(x.group) > -1).map(x => {
          return {
            text: x.title,
            value: x.group
          }
        });
      },
    },
    beforeMount() {
      this.intiHeaders = this.headers;
    },
    created() {

    },
    methods: {
      ShowDelete(id, title) {
        this.deleteId = id;
        this.deleteTitle = title;
        this.deleteDialog = true;
      },
      ConfirmDelete() {
        this.deleteLoading = true;
        this.request({
            method: 'delete',
            url: '/admin/'+ this.module + '/delete/'+this.deleteId,
          })
          .then(response => {
              this.deleteDialog = false
              this.items = this.items.filter(x => x._id != this.deleteId);
              this.deleteId = null;
              this.deleteTitle = '';
          })
          .catch().finally(x => {
            this.deleteLoading = false
          })
      },
      exportList() {
        this.export = true;
        this.getData();
      },
      changeOptions(option) {
        this.options = option;
        if (option.sortDesc.length > 0 && option.sortBy.length > 0) {
          this.isDesc = option.sortDesc[0]; // ? '_desc' : '';
          this.sortOrder = option.sortBy[0];
          this.sortOrder = this.sortOrder.charAt(0).toUpperCase() + this.sortOrder.slice(1)
        }
        this.getData()
      },
      getData() {
        var method = 'post'
        if (this.export)
          this.loadingExport = true;
        else
          this.loading = true;
        var formData = this.CreateFormData(this.filters, this.options.page, this.options.itemsPerPage,
          this
          .sortOrder, this.isDesc, '', this.export)
        formData['groupBy'] = this.groupBy === 0 ? null : this.groupBy
        //var group = this.groupBy === 0 ? null : this.groupBy
        if (this.$route.name == 'RequestList' || this.$route.name == 'Dashboard' && this.$store.getters.getRole == 'Patient') {
          var url = 'Patient/VisitList'
        }
        else {
          var url = '/admin/'+this.module + '/list'
        }
        
        this.request({
            method: method,
            url: url,
            header: {
              //  "Content-Type": "application/json",
            },
            data: formData
            // data: {
            //     "pageNumber":this.options.page,"pageSize":this.options.itemsPerPage,"sortOrder": this.sortOrder,"groupBy": group
            // }
          })
          .then(response => {
            if (response.success) {
              this.items = [];
              var res = response.data;
              var paging = response.pagin;
              this.totalItems = paging.totalItem;
              res.forEach(element => {
                var item = {};
                this.headers.forEach(header => {
                  var name = header.value;
                  if (header.type === 'date')
                    item[header.value] = this.ShowDate(element[name],
                      'date');
                  else if (header.type === 'datetime')
                    item[header.value] = this.ShowDate(element[name],
                      'datetime');
                  else if (header.type === 'time')
                    item[header.value] = this.ShowDate(element[name],
                      'time');
                  else if (header.type === 'number') {
                    item[header.value] = Number(element[name])
                      .toLocaleString();
                  } else
                    item[header.value] = element[name] || '';
                });
                if(item.category){
                  item.category = item.category.name
                }
                this.items.push(item);
              });
            }
          })
          .catch().finally(x => {
            this.loading = false;
            this.export = false;
            this.loadingExport = false;
          })
      },
      WhatColor(stat) {
        if (stat == 0) {
          return 'blue';
        } else if (stat === 1) {
          return 'primary';
        } else if (stat === 2) {
          return 'brown'
        } else if (stat === 3) {
          return 'green';
        } else if (stat === 4) {
          return 'orange';
        } else if (stat === 5) {
          return 'red';
        } else if (stat === 6) {
          return 'red';
        } else if (stat === 7) {
          return 'orange';
        }
      },
      SortRowMethod() {
        this.loader = true
        var arr = []
        this.items.forEach(item => {
          arr.push(item.id)
        })
        this.request({
            method: 'put',
            url: 'Request/OrderUpdate',
            data: {
              requests: arr,
            },
          })
          .then((response) => {
            Vue.notify({
              group: 'foo',
              type: 'success',
              title: 'خطا',
              text: 'انجام شد'
            });
          })
          .catch().finally(x => {
            this.loader = false
          });
      }
    }
  }
</script>

<style>
  td {
    background-color: #f2f2f2;
  }

  td:first-child {
    border-top-right-radius: 10px;
  }

  td:last-child {
    border-top-left-radius: 10px;
  }

  td:first-child {
    border-bottom-right-radius: 10px;
  }

  td:last-child {
    border-bottom-left-radius: 10px;
    border-bottom: none;
  }

  tbody tr {
    height: 50px;
    line-height: 30px;
  }

  table {
    border-collapse: separate;
    border-spacing: 0 .8em !important;
  }
</style>
